exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".oodrive-sign iframe {\n  width: 100%;\n  height: 600px;\n}\n.loading-text {\n  color: #06263e;\n  font-size: 1rem;\n  font-weight: 600;\n  letter-spacing: 0.07rem;\n}\n#oodrive-sign-contract-modal___BV_modal_footer_ {\n  z-index: 9999 !important;\n}\n", ""]);

// exports
